import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaUsers,
  FaBullhorn,
  FaChartLine,
  FaEnvelope,
  FaRupeeSign,
  FaMousePointer,
} from "react-icons/fa";

const BRAND_GRADIENT = "linear-gradient(135deg, #5f2eea, #0a84ff)";

/* ================= WRAPPER ================= */

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 40px 20px;
  font-family: "Poppins", sans-serif;
  color: #fff;
`;

/* ================= HEADER ================= */

const Header = styled.div`
  margin-bottom: 40px;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: ${BRAND_GRADIENT};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Subtitle = styled.p`
  color: #cbd5e1;
  margin-top: 8px;
`;

/* ================= GRID ================= */

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
`;

/* ================= CARD ================= */

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  border-radius: 18px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
`;

const IconWrapper = styled.div`
  font-size: 26px;
  margin-bottom: 16px;
`;

const CardTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 6px;
`;

const Value = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
`;

/* ================= ACTION SECTION ================= */

const Section = styled.div`
  margin-top: 50px;
`;

const SectionTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ActionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
`;

const ActionCard = styled(motion.div)`
  padding: 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  cursor: pointer;
  text-align: center;
`;

const ActionText = styled.p`
  margin-top: 10px;
  font-weight: 600;
`;

/* ================= COMPONENT ================= */

export default function MarketingDashboard() {
  return (
    <Wrapper>
      <Header>
        <Title>Marketing Dashboard</Title>
        <Subtitle>
          Track campaign performance, leads, and revenue insights.
        </Subtitle>
      </Header>

      <Grid>
        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaUsers />
          </IconWrapper>
          <CardTitle>Total Leads</CardTitle>
          <Value>12,450</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaMousePointer />
          </IconWrapper>
          <CardTitle>Click Through Rate</CardTitle>
          <Value>3.8%</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaEnvelope />
          </IconWrapper>
          <CardTitle>Email Subscribers</CardTitle>
          <Value>8,230</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaBullhorn />
          </IconWrapper>
          <CardTitle>Active Campaigns</CardTitle>
          <Value>18</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaChartLine />
          </IconWrapper>
          <CardTitle>Revenue Generated</CardTitle>
          <Value>₹4.2L</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaRupeeSign />
          </IconWrapper>
          <CardTitle>Cost Per Lead</CardTitle>
          <Value>₹38</Value>
        </Card>
      </Grid>

      <Section>
        <SectionTitle>Quick Actions</SectionTitle>

        <ActionGrid>
          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaBullhorn size={24} />
            <ActionText>Create Campaign</ActionText>
          </ActionCard>

          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaChartLine size={24} />
            <ActionText>View Analytics</ActionText>
          </ActionCard>

          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaEnvelope size={24} />
            <ActionText>Send Email Blast</ActionText>
          </ActionCard>
        </ActionGrid>
      </Section>
    </Wrapper>
  );
}